import { BaseModel } from './base';

export interface Territory extends BaseModel {
    name: string;
    franchiseId: number | null;
    regions: string[];
}

export const newTerritory: Territory = {
    id: 0,
    name: '',
    franchiseId: null,
    regions: []
};
